export default __webpack_public_path__ + "static/media/small_discord_line.f8807573.svg";